module.exports = __webpack_public_path__ + "img/6.181289c7.png";